import { enumToNameWithDefault, rawValueToEnumWithDefault } from '@ps-smart-cp/ppfw-client';
import { eligibleBillingProviderNameConfig } from './EligibleBillingProvider.name';

enum EligibleBillingProvider {
  target = 'TARGET',
  notTarget = 'NOT_TARGET',
}

const eligibleBillingProviderMap = new Map([
  ['1', EligibleBillingProvider.target],
  ['2', EligibleBillingProvider.notTarget],
]);

const rawValueToEligibleBillingProvider = rawValueToEnumWithDefault(
  eligibleBillingProviderMap,
  EligibleBillingProvider.target,
);

const eligibleBillingProviderToDisplay = enumToNameWithDefault(
  EligibleBillingProvider,
  eligibleBillingProviderNameConfig,
);

export { EligibleBillingProvider, eligibleBillingProviderToDisplay, rawValueToEligibleBillingProvider };
